module.exports = __webpack_public_path__ + "img/WechatIMG26.39f3587d.png";